import { useDispatch, useSelector } from 'react-redux';
import { savePageFilters } from 'store/Filters/actions/filters';
import { FiltersPageEnum } from 'store/Filters/constants';
import { IRootReducerState } from 'store/store';
import { ViewType } from 'components/ViewTypePicker/ViewTypePicker';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { useQuery } from 'react-query';
import { getMyModels } from 'services/CompanyService';
import i18n, { FALLBACK_LOCALE } from 'providers/i18n/i18n';

export const useSelectedViewType = () => {
  const dispatch = useDispatch();
  const selectedViewType = useSelector(
    (state: IRootReducerState) =>
      state.filtersInfo?.modelsPage?.selectedViewType
  );

  return {
    selectedViewType,
    setSelectedViewType: (viewType: ViewType) =>
      dispatch(
        savePageFilters({
          page: FiltersPageEnum.MODELS,
          data: { selectedViewType: viewType },
        })
      ),
  };
};

export const useGetMyModels = (
  page: number,
  perPage: number,
  searchBy: string,
  categoryId: number | null
) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_MY_MODELS,
      page,
      perPage,
      searchBy,
      categoryId,
      i18n.resolvedLanguage || FALLBACK_LOCALE,
    ],
    queryFn: () => {
      return getMyModels(page, perPage, searchBy, categoryId);
    },
  });
